import { HeaderAnalytics } from '~/modules/main/analytics/controller/navigation.controller'
import { RewardsAnalytics } from '~/modules/main/analytics/controller/rewards.controller'
import { RouletteAnalytics } from '~/modules/main/analytics/controller/roulette.controller'

import { Analytics } from './core'

export const buildAnalytics = (gaApp, libs) => {
  const core = new Analytics(gaApp, libs)

  return {
    libs: core,
    modules: {
      navigation: new HeaderAnalytics(gaApp, core),
      roulette: new RouletteAnalytics(gaApp, core),
      rewards: new RewardsAnalytics(gaApp, core),
    },
  }
}
